export default __webpack_public_path__ + "static/media/centro-atencion.eeba6c4a.svg";